import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import InputMask from "react-input-mask";
import SearchIcon from "@material-ui/icons/Search";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";
import styles from "../../../styles/global-styles";
import { ClientService } from "../../../services/client.service";
import NewClientModal from "../modals/NewClientModal";
import { PhonePlanService } from "../../../services/phonePlan.service";

const useStyles = makeStyles(() => ({
  paper: {
    height: "auto",
    width: "auto",
    background: "white",
    marginTop: 50,
  },
  title: {
    fontWeight: 700,
    color: "#1C2668",
    opacity: 0.5,
    fontSize: 24,
    padding: 14,
  },
  box: {
    margin: "15px 0px 10px 20px",
  },
  label: {
    marginBottom: "1.5vh",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      width: "100%",
      border: "0.2px solid #f2f2f2",
      fontSize: 20,
    },
  },
  telephoneInput: {
    "& .MuiOutlinedInput-root": {
      width: 130,
      border: "0.2px solid #f2f2f2",
      fontSize: 14,
    },
  },
  nameInput: {
    "& .MuiOutlinedInput-root": {
      width: 230,
      border: "0.2px solid #f2f2f2",
      fontSize: 14,
    },
  },
  deleteLink: styles.deleteLink,
  body: styles.body,
  header: styles.header,
  cashPayment: styles.cashPayment,
  creditPayment: styles.creditPayment,
  debitPayment: styles.debitPayment,
  transfPayment: styles.transfPayment,
}));

const ClientInfo = ({
  addAlert,
  detailAlert,
  clientInfo,
  showTitle,
  addClient,
  shoppingCart: { cart },
}) => {
  const classes = useStyles();

  const [queryParams, setqueryParams] = useState({});
  const [dataClient, setdataClient] = useState({});
  const [openModal, setOpenModal] = useState(false);

  const handleChange = ({ target: { name, value } }) => {
    setqueryParams({ ...queryParams, [name]: value });
  };

  const handleSearchClient = async () => {
    try {
      const { data } = await ClientService.getOneClientWithParams(queryParams);
      if (data) {
        setdataClient(data);
        clientInfo(true, data);
      } else {
        const notClientFound = {
          notClientFound:
            "No se encontró ningun cliente con esos parametros de búsqueda",
        };
        throw notClientFound;
      }
    } catch (error) {
      console.log("error", error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: error.notClientFound ? "warning" : "error",
        message: error.notClientFound ? error.notClientFound : error.msgs,
      });
    }
  };

  const handleClientCreated = (clientCreated, message, clientObject) => {
    addAlert({ showAlert: true });
    if (clientCreated) {
      detailAlert({
        severity: "success",
        message: message,
      });
      setdataClient(clientObject);
      clientInfo(true, clientObject);
    } else {
      detailAlert({
        severity: "error",
        message: message,
      });
    }
  };

  const handleRemoveClient = async () => {
    clientInfo(false, dataClient);
    setdataClient({});

    const phonePlanProduct = Object.values(cart).filter(
      (item) => item.phonePlanId !== null
    );
    if (phonePlanProduct && phonePlanProduct.length) {
      try {
        const phonePlanIds = phonePlanProduct.map((item) => item.phonePlanId);
        await PhonePlanService.updateBulkPhonePlan(
          { clientId: null },
          phonePlanIds
        );
        console.log("phonePlanIds", phonePlanIds);
      } catch (error) {
        addAlert({ showAlert: true });
        detailAlert({
          severity: "error",
          message: error.msgs,
        });
      }
    }
  };
  return (
    <>
      {showTitle && (
        <Typography variant="h4" component="h4" className={classes.title}>
          Datos del cliente
        </Typography>
      )}
      <Grid
        container
        style={{ marginLeft: 1 }}
        spacing={3}
        direction="row"
        justify="flex-start"
      >
        <Grid item container>
          <div
            style={{
              margin: "10px 0px",
            }}
            className={classes.body}
          >
            Buscar datos del cliente (nombre completo o télefono)
          </div>
        </Grid>
        <Grid item>
          <TextField
            name="name"
            className={classes.nameInput}
            variant="outlined"
            onChange={handleChange}
            inputProps={{ maxLength: 40 }}
            value={queryParams.name || ""}
            placeholder="Nombre completo"
          />
        </Grid>
        <Grid item>
          <InputMask
            mask="9999999999"
            maskChar=""
            value={queryParams.telephone || ""}
            onChange={handleChange}
          >
            {() => (
              <TextField
                className={classes.telephoneInput}
                name="telephone"
                variant="outlined"
                placeholder="# teléfono"
              />
            )}
          </InputMask>
        </Grid>
        <Grid item>
          <Button
            disabled={Object.values(queryParams).length === 0}
            className={classes.rightButton}
            onClick={() => handleSearchClient()}
            variant="contained"
            color="primary"
            endIcon={<SearchIcon color="secondary" />}
          >
            Buscar
          </Button>
        </Grid>
        {addClient && (
          <Grid item>
            <Button
              className={classes.rightButton}
              onClick={() => setOpenModal(true)}
              variant="contained"
              color="primary"
              endIcon={<SearchIcon color="secondary" />}
            >
              Nuevo cliente
            </Button>
          </Grid>
        )}
      </Grid>

      {Object.values(dataClient).length > 0 && (
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
        >
          <Grid item xs={12} sm={12} md={10} style={{ margin: "10px 25px " }}>
            <span
              className={classes.deleteLink}
              onClick={() => handleRemoveClient()}
            >
              Quitar cliente
            </span>
          </Grid>
          <Grid item xs={12} sm={12} md={10}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Nombre del cliente
              </Typography>
              <TextField
                className={classes.textField}
                name="name"
                fullWidth
                disabled
                value={dataClient.name || ""}
                variant="outlined"
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={5}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Teléfono
              </Typography>

              <TextField
                className={classes.inputField}
                name="telephone"
                value={dataClient.telephone}
                disabled
                variant="outlined"
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={5} style={{ marginLeft: 10 }}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Email
              </Typography>
              <TextField
                className={classes.inputField}
                name="email"
                disabled
                value={dataClient.email || ""}
                variant="outlined"
              />
            </Box>
          </Grid>
        </Grid>
      )}

      {openModal && (
        <NewClientModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          newClientCreated={handleClientCreated}
        />
      )}
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

const mapStateToProps = (state) => ({
  shoppingCart: state.shoppingCart,
});

export default connect(mapStateToProps, dispatch)(ClientInfo);
